import { createWorkspace } from "./data";
import type { Workspace } from "./types";

const STORAGE_KEY = "stillwater-trust-workspace-v1";

export function loadWorkspace(): Workspace {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return createWorkspace();
    const parsed = JSON.parse(stored) as Workspace;
    return parsed.version === 1 ? parsed : createWorkspace();
  } catch {
    return createWorkspace();
  }
}

export function saveWorkspace(workspace: Workspace): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...workspace, lastUpdated: new Date().toISOString() }));
}

export function resetWorkspace(): Workspace {
  const next = createWorkspace();
  saveWorkspace(next);
  return next;
}
